import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './estilodashuser.css';
import api from '../api';
import { baixarArquivoProtegido } from '../downloadArquivo';

export default function Downloads() {
  const { t } = useTranslation();
  const [arquivos, setArquivos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [baixando, setBaixando] = useState('');
  const [erroDownload, setErroDownload] = useState('');
  const legalNotices = t('dashboard.downloads.legal', { returnObjects: true });

  useEffect(() => {
    const fetchArquivos = async () => {
      try {
        setLoading(true);
        const response = await api.get('/api/arquivos');
        setArquivos(response.data || []);
      } catch (error) {
        console.error('Erro ao listar arquivos para download:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchArquivos();
  }, []);

  const baixarArquivo = async (nome) => {
    try {
      setBaixando(nome);
      setErroDownload('');
      await baixarArquivoProtegido(nome);
    } catch (error) {
      console.error('Erro ao baixar arquivo:', error);
      setErroDownload(t('dashboard.downloads.downloadError'));
    } finally {
      setBaixando('');
    }
  };

  const getFileType = (nome) => {
    const extension = String(nome).split('.').pop();
    return extension && extension !== nome
      ? extension.toUpperCase().slice(0, 5)
      : 'ARQ';
  };

  return (
    <div className="content-page">
      <div className="content-card">
        <div className="content-page-header">
          <div>
            <h2>{t('dashboard.downloads.title')}</h2>
            <p>{t('dashboard.downloads.intro')}</p>
          </div>
        </div>

        <div className="cliente-help-box" style={{ marginBottom: 14 }}>
          <strong>{t('dashboard.downloads.tipTitle')}</strong> {t('dashboard.downloads.tip')}
        </div>

        {loading && <p className="lic-loading">{t('dashboard.downloads.loading')}</p>}

        {!loading && arquivos.length === 0 && (
          <div className="cliente-empty-box">{t('dashboard.downloads.empty')}</div>
        )}

        {erroDownload && <div className="alert-box alert-error" role="alert">{erroDownload}</div>}

        {!loading && arquivos.length > 0 && (
          <div className="client-download-list">
            {arquivos.map((nome) => (
              <div className="client-download-row" key={nome}>
                <div className="client-download-type" aria-hidden="true">
                  {getFileType(nome)}
                </div>
                <div className="client-download-info">
                  <div className="client-download-name">{nome}</div>
                </div>
                <button
                  type="button"
                  className="client-download-button"
                  onClick={() => baixarArquivo(nome)}
                  disabled={baixando === nome}
                  aria-label={`${t('common.download')}: ${nome}`}
                >
                  <span aria-hidden="true">↓</span>
                  {baixando === nome
                    ? t('dashboard.downloads.downloading')
                    : t('common.download')}
                </button>
              </div>
            ))}
          </div>
        )}

        <div className="legal-box">
          <strong>{t('dashboard.downloads.legalTitle')}</strong>
          {Array.isArray(legalNotices) && legalNotices.map((notice) => (
            <p key={notice}>{notice}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
